<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12 content-margin">
						<div class="content">
							<div class="content-header">
								<h2>
									Edit source ({{ form.name }})
								</h2>
							</div>
							<div class="content-body">
								<el-form @submit.prevent.native="handleSubmit('form')" :model="form" :rules="rules" ref="form">
									<div class="mobile-hide">
										<div class="row">
											<div class="col-lg-6 col-md-12">
												<el-form-item label="Start/End date">
													<el-date-picker
														v-model="dataRange"
														type="daterange"
														unlink-panels
														range-separator="-"
														format="dd-MM-yyyy"
														value-format="yyyy-MM-dd"
														start-placeholder="Start date"
														end-placeholder="End date"
														:picker-options="pickerOptions"
													/>
												</el-form-item>
											</div>
										</div>
									</div>
									<div class="mobile-show">
										<div class="row">
											<div class="col-lg-12">
												<el-form-item>
													<el-date-picker
														v-model="form.start"
														format="dd-MM-yyyy"
														value-format="yyyy-MM-dd"
														type="date"
														:picker-options="pickerOptions"
														placeholder="Start date">
													</el-date-picker>
												</el-form-item>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-12">
												<el-form-item>
													<el-date-picker
														v-model="form.end"
														format="dd-MM-yyyy"
														value-format="yyyy-MM-dd"
														type="date"
														:picker-options="pickerOptions"
														placeholder="End date">
													</el-date-picker>
												</el-form-item>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Cost" prop="cost">
												<el-input type="text" v-model="form.cost" placeholder="Please enter cost"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item>
												<el-button native-type="submit" type="primary" plain>Save</el-button>
												<el-button plain @click="handleCancel()">Cancel</el-button>
											</el-form-item>
										</div>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'
import { mapState } from 'vuex'

export default {
	name: 'SourceEdit',
	metaInfo () {
		return {
			title: 'Edit source',
		}
	},
	data () {
        return {
			loading: true,
			roles: [],
			dataRange: null,
			form: {
				cost: null,
				start: null,
				end: null,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				}
			},
			rules: {
				cost: [
					{ required: true, message: 'Please enter cost', trigger: 'blur' },
				]
			}
        }
    },
	computed: {
        ...mapState(['user'])
	},
	watch: {
		dataRange (value) {
			this.form.start = value[0]
			this.form.end = value[1]
		}
	},
	mounted () {
		if (parseInt(this.user.role) !== 1) {
			this.$router.push('/analytics')
		} else {
			this.loadData()
		}
	},
	methods: {
		loadData () {
			return HTTP({
				method: 'GET',
				url: '/sources/' + this.$route.params.id,
				crossdomain: true
			})
			.then(response => {
				this.form = response.data
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleCancel () {
			this.$router.push('/sources')
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					return HTTP({
						method: 'PUT',
						url: '/update-cost',
						data: this.form,
						crossdomain: true,
					})
					.then(() => {
						this.loading = false
						this.$notify({
							title: 'Success',
							message: 'Source has been updated',
							type: 'success',
							position: 'bottom-right',
							duration: 2500
						})
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
